const setupMobileMenu = () => {
  const hamburgerMenu = document.getElementById('header__nav-icon')
  const html = document.getElementsByTagName('html')[0]

  hamburgerMenu.addEventListener('click', () => {
    if(hamburgerMenu.classList.contains('mobile-open')) {
      html.style.overflow = 'scroll'
      document.body.classList.remove('mobile-open')
      hamburgerMenu.classList.remove('mobile-open')
      return
    }
    html.style.overflow = 'hidden'
    document.body.classList.add('mobile-open')
    hamburgerMenu.classList.add('mobile-open')
  })
}

export default setupMobileMenu